module.exports = function() {
  return new Worker(__webpack_public_path__ + "7b49d7f5bb50251e4fff.worker.js");
};